import React from "react";
import {
    Layout,
    message,
    Form,
    Row,
    Col,
    Switch
} from "antd";
import MiCompAPI from "./../../util/api";
import TableWrapper from '../elements/TableWrapper';
import img from '../../assets/img/At the office-pana 1.png';
const { Content } = Layout;
class FD extends React.Component {
    columns = [
        {
            title: 'Type of Notification',
            dataIndex: 'notificationType',

        },
        {
            title: "Allow",
          
            width: 180,
            render: (text, record) => {
                return (
                    <div style={{ display: 'flex' }}>
                        <Switch defaultChecked={this.state.Notification.find(x=>x.masterId===record.id)&&this.state.Notification.find(x=>x.masterId===record.id).isEnable} style={{ marginRight: '10px' }} 
                        onChange={(e) => {
                            var obj={
                                id:this.state.Notification.find(x=>x.masterId===record.id)?this.state.Notification.find(x=>x.masterId===record.id).id:0,
                                masterId:record.id,
                                isEnable:e
                            }
                            this.InsertUpdateNotificationPermissions(obj);

                        }} />
                    </div>
                );
            },
        },
    ];
    constructor(props) {
        super(props);
        this.state = {
            NotificationMaster:[],
            Notification:[]
        };
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    componentDidMount = () => {
                this.GetNotificationPermission();

    }
    GetNotificationPermission() {        
        this.api.invoke(
            "GetNotificationPermission",
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.setState({ Notification: data.data });
                        this.GetAllNotificationMaster();

                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            }
        );
    }
    InsertUpdateNotificationPermissions(val) {        
        this.api.invoke(
            "InsertUpdateNotificationPermissions",
            "post",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.GetNotificationPermission();

                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            },val
        );
    }
    GetAllNotificationMaster() {
        this.setState({ loadSettings: true });
        this.api.invoke(
            "GetAllNotificationMaster",
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.setState({ NotificationMaster: data.data, loadSettings: false });
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            }
        );
    }
    render() {
        return (

            <Content>
                <div className="mi_main_div">
                    <div className="mi_box" style={{marginLeft:'8px',marginRight: '8px',marginTop:'20px'}}>
                        <Row span={24}>
                            <Col span={18}>
                                <h4 className="mi_box_h4">Notification Settings</h4>
                            </Col>
                            <Col span={6}>
                                <img alt="example" style={{ height: '182px', marginTop: '-80px'}} src={img} />
                            </Col>
                        </Row>
                    </div>
                    <div className="mi_main" >
                        <Row>
                            <Col md={6} sm={24}></Col>
                            <Col md={12} sm={24}>                              
                                <TableWrapper rowkey="id" columns={this.columns} data={this.state.loadSettings ? null :this.state.NotificationMaster}title="Notification Settings" loading={this.state.loadSettings} />
                            </Col>
                            <Col md={6} sm={24}></Col>
                        </Row>
                    </div>
                </div>
            </Content>
        );
    }
}
const NotificationSettings = Form.create()(FD);
export default NotificationSettings;